<template>
<div class="chapter">
<div class="inner_page">
<p class="head">ACKNOWLEDGEMENTS</p>
<p class="noindent1">My utmost thanks to the following for providing their barns, stories and assistance for this project:</p>
<p class="noindent3">(in order of appearance)</p>
<p class="ref">The Timber Framers Guild</p>
<p class="ref">Jane Fox, Freeport</p>
<p class="ref">Freeport Historical Society</p>
<p class="ref">Tom and Diana Allen, Sebago</p>
<p class="ref">Bridgton Historical Society</p>
<p class="ref">David and Terry Gagnon, Denmark</p>
<p class="ref">Mike Deering, Saco</p>
<p class="ref">Lois Deering Starbird, Solon</p>
<p class="ref">Dan and Sarah Pierce, New Gloucester</p>
<p class="ref">George, Gene and Mary Lou Stacey, Hiram</p>
<p class="ref">Sally Williams, Hiram</p>
<p class="ref">Rick Gerrish, Milo</p>
<p class="ref">Milo Historical Society</p>
<p class="ref">Richard and Geraldine Anderson, Scarborough</p>
<p class="ref">Carmel Morin, New Gloucester</p>
<p class="ref">Ryan Tripp, New Gloucester</p>
<p class="ref">Garin and Sarah Smith, Skowhegan</p>
<p class="ref">Stephanie Calder, Skowhegan</p>
<p class="ref">Bob Bartlett (deceased), formerly of Oxford</p>
<p class="ref">Elizabeth Dominic, Searsport</p>
<p class="ref">Hank and Heidi Thorburn, Harpswell</p>
<p class="ref">Gail Hart, Harpswell</p>
<p class="ref">Peter, George and James Haines, Bethel</p>
<p class="ref">Randall, Jill and Allison Bates, New Vineyard</p>
<p class="ref">Dan and Claudia Sortwell, Wiscasset</p>
<p class="ref">Clarence and Juliet Plourde, Caribou</p>
<p class="ref">Dan Deveau, Cyr Plantation</p>
<p class="ref">Ken Arndt, Presque Isle</p>
<p class="ref">Shawn Michaud, Easton</p>
<p class="ref">Noah Yoder, Fort Fairfield</p>
<p class="ref">Granville “Peaunt” Perkins, Fort Fairfield</p>
<p class="ref">John and Marie Dudley, Alexander</p>
<p class="ref">Richard Carlow, Wesley</p>
<p class="ref">Aaron Bell and Carly DelSignore, Edmunds Township</p>
<p class="ref">Roger Knight, Scarborough</p>
<p class="ref">Jim Leary, Saco</p>
<p class="ref">George Hall, Windham</p>
<p class="ref">Jeremie Berube, Arundel</p>
<p class="ref">Scott Hatch, Harrison</p>
<p class="ref">Scott Burner, Windham</p>
<p class="ref">Mike Franck, Gorham</p>
<p class="noindent3">A very special thanks also goes out to those who backed this project on <i>Kickstarter</i> and became “barn backers.”</p>
<p class="ref">Joey Brunelle, San Francisco, California</p>
<p class="ref">Angelo Castigliola, Biddeford, Maine</p>
<p class="ref">Gene Cetrone, Rinebeck, New York</p>
<p class="ref">Bill and Ruth Crane, Windham, Maine</p>
<p class="ref">John and Karen DenBleyker, Millville, New Jersey</p>
<p class="ref">Tama Benson Donovan, Ipswich, Massachusetts</p>
<p class="ref">Bob Fowler, New Gloucester, Maine</p>
<p class="ref">Donna Godfrey, Raymond, Maine</p>
<p class="ref">James Haines, Bethel, Maine</p>
<p class="ref">Sam Hotchkiss, Portland, Maine</p>
<p class="ref">Julie Jenkins, Bangor, Maine</p>
<p class="ref">Louise Knapp, Hebron, Maine</p>
<p class="ref">Caroline Loupe, New Gloucester, Maine</p>
<p class="ref">Dave Martel, Saco, Maine</p>
<p class="ref">Paul and Nancy Michaud, Caribou, Maine</p>
<p class="ref">Fabien and Brenda Pelletier, Wallagrass, Maine</p>
<p class="ref">Deborah Perkins, Poland, Maine</p>
<p class="ref">Janine Pineo, Hudson, Maine</p>
<p class="ref">Bill Punsky, Cape Elizabeth, Maine</p>
<p class="ref">Andrew and Nina Roth-Wells, Georgetown, Maine</p>
<p class="ref">Caroline Sample, Cumberland, Maine</p>
<p class="ref">Susan Simonson, Westbrook, Maine</p>
<p class="ref">Wendy Smith, Windham, Maine</p>
<p class="ref">Daniel and Claudia Sortwell, Wiscasset, Maine</p>
<p class="ref">Jeff Stanton, South Portland, Maine</p>
<p class="ref">Iain and Ada Dawn Stenhouse, Poland, Maine</p>
<p class="ref">Jonathan Stern, San Diego, California</p>
<p class="ref">Chandler Vreeland, Marietta, Georgia</p>
<p class="ref">John Warden, Alexandria, Virginia</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?e5002e36